<template>
	<v-container class="evaluation">
		<v-layout row>
			<v-btn @click="openProjectView">
				Podgląd projektu
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn @click="print" class="mr-3 no-print">Wydrukuj</v-btn>
		</v-layout>

		<v-card-title class="mt-3 mb-3">
			<div>
				<h2 class="mb-3">Ocena przebiegu współpracy</h2>
				<div class="bidder-evaluation-card evaluation-font-size">
					<div>
						<strong class="mr-3">Nazwa projektu:</strong> {{viewData.projectName}}
					</div>
					<div>
						<strong class="mr-3">Numer projektu:</strong> {{viewData.projectCode}}
					</div>
					<div>
						<strong class="mr-3">Suma kontrolna:</strong> {{viewData.controlSum}}
					</div>
					<div>
						<strong class="mr-3">Nazwa oferenta:</strong> {{viewData.bidderName}}
					</div>
					<div v-if="viewData.mutualBidders.length">
						<strong class="mr-3">{{ viewData.mutualBidders.length === 1 ? 'Nazwa współoferenta:' : 'Nazwy współoferentów:' }}</strong>
						{{ viewData.mutualBidders.join(', ') }}
					</div>
					<div>
						<strong class="mr-3">Okres realizacji:</strong> {{realizationPeriod}}
					</div>
					<div>
						<strong class="mr-3">Kwota dofinansowania:</strong>
						{{getAmountFormatted(viewData.donationAmount)}} PLN
					</div>
					<div class="mt-3">
						<strong class="mr-3">Raport utworzony przez:</strong> {{viewData.creatorName}}
					</div>
					<div v-if="viewData.finisherName">
						<strong class="mr-3">Raport zakończony przez:</strong> {{viewData.finisherName}}
					</div>
					<div v-if="viewData.firstSendDate">
						<strong class="mr-3">Data pierwszego wysłania:</strong> {{viewData.firstSendDate}}
					</div>
					<div v-if="viewData.latestSendDate">
						<strong class="mr-3">Data ostatniego wysłania:</strong> {{viewData.latestSendDate}}
					</div>
				</div>
			</div>
		</v-card-title>

		<hr class="ma-4">

		<vue-form-generator
			name="generator"
			ref="vfg"
			:model="evaluationData.model"
			:options="formGenerator.formOptions"
			:schema="formGenerator.currentSchema"
			v-if="viewData.showGenerator">
		</vue-form-generator>

		<hr class="ma-4">

		<div v-for="(ev, index) in evaluationData.points" v-bind:key="index">
			<strong>{{ ev.bidderName }}</strong>
			<v-container class="text-xs-center no-print">
				<v-text-field
					browser-autocomplete="off"
					name="points"
					:disabled="configuration.disabled"
					type="number"
					v-model="ev.points"
					hint="Od 0 do 5 z mnożnikiem 2"
					label="Ocena"
					aria-label="evaluation points"
					for="bidder-evaluation-form-view-evaluation"
					id="bidder-evaluation-form-view-evaluation"
					persistent-hint>
				</v-text-field>
				<h3> {{ ev.points * 2 }} </h3>
				<br/>
			</v-container>
			<div class="print-only d-none ml-5 evaluation-font-size" style="page-break-inside: avoid">
				<div class="mt-3">Ocena (od 0 do 5 z mnożnikiem 2): <strong class="ml-3">{{ev.points}}</strong>
				</div>
				<div class="mt-2">Ocena ostateczna: <strong class="ml-3">{{ ev.points * 2 }}</strong></div>
			</div>
		</div>

		<v-btn v-if="!configuration.disabled" @click="send" color="success">
			<v-icon class="mr-2 white--text">send</v-icon>
			Wyślij
		</v-btn>
		<v-btn v-if="evaluationData.status !== 'FINISHED'" @click="saveEvaluation" color="info">
			<v-icon class="mr-2 white--text">save</v-icon>
			Zapisz ocenę
		</v-btn>
	</v-container>
</template>

<script>
	import {Api} from "@/api";
	import {BidderEvaluation} from "@/api/generated/BidderEvaluation";
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import {Numbers} from "@/utils/Numbers";
	import {Files} from "@/utils/Files";

	export default {
		name: "BidderEvaluationFormView",

		watch: {
			"evaluationData.model": {
				handler() {
					this.applyGenericForm(this.configuration.form);
				},
				deep: true,
			},
		},

		data () {
			return {
				evaluationData: {
					model: undefined,
					status: '',
					points: [],
				},

				configuration: {
					form: "",
					disabled: false,
				},
				viewData: {
					showGenerator: false,

					projectTitle: "",
					projectCode: "",
					country: "",
					author: "",
					firstSendDate: "",
					latestSendDate: "",
          mutualBidders: []
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: [],
				},

			};
		},

		computed: {
			realizationPeriod() {
				return this.viewData.startDate + " - " + this.viewData.endDate;
			},
		},

		created () {
			this.loadData();
			this.$store.commit("loadProjectPanelPermissions", {context: this, projectId: this.$route.params.projectId});
		},


		methods: {
			async loadData () {
				await Api.syncGet(this, "/bidder-evaluation/configuration?contestId=".concat(this.$route.params.contestId), successResponse => {
					this.configuration.form = genericFormUtil.decodeSchema(successResponse.schema);
				});

				BidderEvaluation.get(this, this.$route.params.evaluationId, success => {
					this.evaluationData.status = success.evaluationStatus;
					if (this.evaluationData.status === "FINISHED" && !this.hasProjectPanelAdminModificationAccess()) {
						this.configuration.disabled = true;
					}
					if (success.filledForm === null) {
						this.evaluationData.model = genericFormUtil.buildModelFromSchema(this.configuration.form).sections[0].fields;
					} else {
						this.evaluationData.model = genericFormUtil.decodeSchema(success.filledForm);
					}

					this.evaluationData.points = success.points.map(item => {
            item.points = item.points / 2;
            return item;
          });
					this.applyGenericForm(this.configuration.form);
					this.viewData = success;
					this.viewData.showGenerator = true;
				});
			},
			hasProjectPanelAdminModificationAccess(){
				return this.$store.state.projectPanelPermissions.hasProjectPanelAdminModificationAccess;
			},

      openProjectView() {
        this.$router.openInNewTab('/view/project/' + this.$route.params.projectId);
      },

			async print () {
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getBidderEvaluationPrintUrl(
						this.$route.params.contestId,
						this.$route.params.projectId,
						this.$route.params.evaluationId),
					"ocena_przebiegu_współpracy.pdf");
			},

			applyGenericForm (form) {
				let schema = genericFormUtil.getSectionSchemaFromSchema(form, 0, this.configuration.disabled);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = this.evaluationData.model;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
			},


			saveEvaluation () {
				BidderEvaluation.put(this, this.$route.params.evaluationId, this.prepareFormData(), successResponse => {
					this.$messagesBus.$emit("success", "Pomyślnie zapisano ocenę", successResponse);
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zapisać oceny", errorResponse);
				});
			},

			async send () {
				let validationPromise = await this.$refs.vfg.validate();
				if (validationPromise.length > 0) {
					return;
				}

				if (this.evaluationData.points.some(p => p.points < 0) || this.evaluationData.points.some(p => p.points > 5)) {
					this.$messagesBus.$emit("error", "Proszę wpisać ocenę w zakresie od 0 do 5 pkt");
					return;
				}
				let data = this.prepareFormData();
				BidderEvaluation.putFinish(this, this.$route.params.evaluationId, data, successResponse => {
					this.$messagesBus.$emit("success", "Ocena została wysłana!", successResponse);
					this.$router.push("/app/".concat(this.$route.params.contestId).concat("/project-panel/").concat(this.$route.params.projectId).concat("/evaluation"));
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się wysłać oceny", errorResponse);
				});
			},

			prepareFormData() {
        let pointsDeepCopy = JSON.parse(JSON.stringify(this.evaluationData.points));
				return {
					filledForm: genericFormUtil.encodeSchema(this.evaluationData.model),
					points: pointsDeepCopy.map(item => {
            item.points = item.points * 2;
            return item;
          })
				};
			},

			getAmountFormatted(x) {
				return Numbers.methods.formatMoney(x);
			}
		},
	};
</script>

<style scoped>

</style>
